export const primary = [
    { url: "/", label: "Startseite" },
    { url: "/anwendungen", label: "Anwendungen" },
    { url: "/glossar", label: "Glossar" },
    { url: "/kontakt", label: "Kontakt" },
];
export const secondary = [
    { url: "/rechtliches", label: "Rechtliches" },
    { url: "/impressum", label: "Impressum" },
    { url: "/barrierefreiheit", label: "Barrierefreiheit" },
    { url: "https://www.stadt-zuerich.ch", label: "© Stadt Zürich 2018" }
];



// WEBPACK FOOTER //
// ./src/routes.ts